module.exports = __webpack_public_path__ + "img/48_lexus.ee56e6bf.jpg";